"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalDocumentation = void 0;
const codegen_1 = require("@azure-tools/codegen");
class ExternalDocumentation extends codegen_1.Initializer {
    constructor(url, initializer) {
        super();
        this.url = url;
        this.apply(initializer);
    }
}
exports.ExternalDocumentation = ExternalDocumentation;
//# sourceMappingURL=external-documentation.js.map